import apiClient from './client'
import API from '@/api/API'

export interface SourceInsightResponse {
  id: string
  source_id: string
  insight_type: string
  content: string
  created?: string
  updated?: string
  deleted?: boolean
}

export interface CreateSourceInsightRequest {
  transformation_id: string  // legacy name, maps to skill_id on backend
  language?: string
}

export const insightsApi = {
  listForSource: async (sourceId: string) => {
    const response = await apiClient.get<SourceInsightResponse[]>(`${API.sources.base}/${sourceId}/insights`)
    return response.data
  },

  get: async (insightId: string) => {
    const response = await apiClient.get<SourceInsightResponse>(`${API.insights.base}/${insightId}`)
    return response.data
  },

  create: async (sourceId: string, data: CreateSourceInsightRequest) => {
    const response = await apiClient.post<SourceInsightResponse>(
      `${API.sources.base}/${sourceId}/insights`,
      data
    )
    return response.data
  },

  delete: async (insightId: string) => {
    const response = await apiClient.delete<{ message: string }>(`${API.insights.base}/${insightId}`)
    return response.data
  }
}
